<div class="flex-direction-column gap-5">
  @if (label) {
    <span class="campo-label">{{ label }}</span>
  }
  <div class="campo-input-wrapper">
    <img [src]="icone" alt="" class="campo-input-icone" />
    <input
      class="campo-input-base campo-input-com-icone"
      [class.campo-input-erro]="erro"
      type="text"
      inputmode="numeric"
      placeholder="00:00"
      maxlength="7"
      [disabled]="disabled"
      [value]="valor"
      (input)="receberValor($event)"
      (blur)="aoTocar()" />
  </div>
  @if (erro) {
    <span class="campo-erro-texto">{{ erro }}</span>
  }
</div>
